let PromptTipAndDot = xClass("PromptTip", function () {
    return cc.CSLoader.createNode("cocos/homeScene_number99.csb")
})
PromptTipAndDot.prototype.ctor = function () {
    let self = this
    self.num = self.getChildByName("txt")
    self.num.setAnchorPoint(0.5, 0.5)
    self.num.setPosition(-1, -4)
    self.num.setScale(1.3)
}
PromptTipAndDot.prototype.getNum = function () {
    return tonumber(this.num.getString())
}
PromptTipAndDot.prototype.setNum = function (num) {
    this.num.setString(num)
    this.num.setVisible(num > 0);
}
module.exports = PromptTipAndDot